import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { Typography } from "@mui/material";
import Tab from "@mui/material/Tab";
import { useEffect, useState } from "react";
import SocialPeopleListItemCompanyShort from "./SocialPeopleListItemCompanyShort";
import SocialPeopleListItemPeopleShort from "./SocialPeopleListItemPeopleShort";
import { useAllPeopleWeight } from "./apiPeopleWeight";
import ListShort from "components/ui/atoms/ListShort";
import { useAllPeopleCompanyWeight } from "models/social/apiPeopleCompanyWeight";

const defaultState = {
  same_company: false,
  people_1__in_team: 1,
  ordering: "-weight",
  offset: 0,
};

const SocialTabList = ({ activeTab, handleChange }) => {
  return (
    <TabContext value={activeTab}>
      <TabList onChange={handleChange} variant="scrollable" ringstyle="ringapp">
        <Tab
          ringstyle="ringapp"
          label={
            <Typography variant="caption" noWrap sx={{ p: 0.6 }}>
              Ring link
            </Typography>
          }
          value="Ring link"
          wrapped
        />
        <Tab
          ringstyle="ringapp"
          label={
            <Typography variant="caption" noWrap sx={{ p: 0.6 }}>
              Company link
            </Typography>
          }
          value="Company link"
          wrapped
        />
        <Tab
          ringstyle="ringapp"
          label={
            <Typography variant="caption" noWrap sx={{ p: 0.6 }}>
              People link
            </Typography>
          }
          value="People link"
          wrapped
        />
      </TabList>
    </TabContext>
  );
};

const SocialPeopleWidget = ({ peopleId }) => {
  const [activeTab, setActiveTab] = useState("Ring link");
  const [state, setState] = useState(defaultState);
  const [fetchParams, setFetchParams] = useState(null);
  const { data: peopleCompanyWeight, status: peopleCompanyWeightStatus } =
    useAllPeopleCompanyWeight(fetchParams);
  const { data: peopleWeight, status: peopleWeightStatus } =
    useAllPeopleWeight(fetchParams);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  useEffect(() => {
    switch (activeTab) {
      case "Ring link":
        setState({
          ...state,
          same_company: false,
          people_1__in_team: 1,
          offset: 0,
        });
        break;
      case "Company link":
        setState({
          ...state,
          same_company: false,
          people_1__in_team: 0,
          offset: 0,
        });
        break;
      case "People link":
        setState({
          ...state,
          same_company: false,
          people_1__in_team: 0,
          offset: 0,
        });
        break;
      default:
        break;
    }
  }, [activeTab]);

  useEffect(() => {
    setFetchParams({
      people: [peopleId],
      ...state,
    });
  }, [peopleId, state]);

  return (
    <ListShort
      title="Socials"
      resource={
        activeTab === "Company link" ? peopleCompanyWeight : peopleWeight
      }
      resourceStatus={
        activeTab === "Company link"
          ? peopleCompanyWeightStatus
          : peopleWeightStatus
      }
      state={state}
      setState={setState}
      TabList={
        <SocialTabList activeTab={activeTab} handleChange={handleChange} />
      }
      ListItemComponent={
        activeTab === "Company link"
          ? SocialPeopleListItemCompanyShort
          : SocialPeopleListItemPeopleShort
      }
      emptyMessage="No socials"
      pagination
    />
  );
};

export default SocialPeopleWidget;
